var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CallTypesSelector',{attrs:{"value":_vm.value.call_types},on:{"input":_vm.updateCallTypes}}),_c('PeriodSelector',{attrs:{"value":_vm.value.period},on:{"input":_vm.updatePeriod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }